function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from "react";
import { PREFETCH_TYPES } from "constants/prefetch-constants";
import { getTypeformImagesPrefetchByCountry } from "constants/typeform-contact-sales";
import { shouldUseNewTypeformVariant } from "services/ab-tests/acquisition-ab-test-service";
const TYPEFORM_FONT_CSS_FILE = "https://font.typeform.com/dist/google/roboto/index.css";
const TYPEFORM_ROBOTO_400_FONT = "https://font.typeform.com/dist/google/roboto/files/roboto-latin-400-normal.woff2";
const TYPEFORM_ROBOTO_700_FONT = "https://font.typeform.com/dist/google/roboto/files/roboto-latin-700-normal.woff2";
const MONDAY_LOGO = "https://images.typeform.com/images/2GR8rmBChTYm";
const STATIC_ASSETS_HREFS = [
    TYPEFORM_FONT_CSS_FILE,
    TYPEFORM_ROBOTO_400_FONT,
    TYPEFORM_ROBOTO_700_FONT,
    MONDAY_LOGO
];
const PREFETCHED_DOMAINS = [
    "https://form.typeform.com"
];
const PRECONNECT_DOMAINS = PREFETCHED_DOMAINS;
const PrefetchedTypeformAssetsContext = /*#__PURE__*/ createContext("PrefetchedTypeformAssets");
export const PrefetchTypeformAssetsProvider = (props)=>{
    const { children, cloudfrontViewerCountry, useNewTypeformUSVariant, abTests } = props;
    const [prefetchedTypeformAssetsLinks, setPrefetchedTypeformAssetsLinks] = useState([]);
    const getNewVariantForTest = useNewTypeformUSVariant || shouldUseNewTypeformVariant(abTests);
    useEffect(()=>{
        const setData = function() {
            var _ref = _async_to_generator(function*() {
                const typeformAssetsLinks = [];
                // dns prefetches
                PREFETCHED_DOMAINS.forEach((href)=>{
                    typeformAssetsLinks.push({
                        type: PREFETCH_TYPES.DNS_PREFETCH,
                        href
                    });
                });
                // pre-connects
                PRECONNECT_DOMAINS.forEach((href)=>{
                    typeformAssetsLinks.push({
                        type: PREFETCH_TYPES.PRECONNECT,
                        href
                    });
                });
                // static assets
                STATIC_ASSETS_HREFS.forEach((href)=>{
                    typeformAssetsLinks.push({
                        type: PREFETCH_TYPES.PREFETCH,
                        href
                    });
                });
                const dynamicAssets = getTypeformImagesPrefetchByCountry(cloudfrontViewerCountry, getNewVariantForTest);
                dynamicAssets && dynamicAssets.forEach((href)=>{
                    typeformAssetsLinks.push({
                        type: PREFETCH_TYPES.PREFETCH,
                        href
                    });
                });
                setPrefetchedTypeformAssetsLinks(typeformAssetsLinks);
            });
            return function setData() {
                return _ref.apply(this, arguments);
            };
        }();
        setData();
    }, [
        cloudfrontViewerCountry
    ]);
    return /*#__PURE__*/ _jsx(PrefetchedTypeformAssetsContext.Provider, {
        value: prefetchedTypeformAssetsLinks,
        children: children
    });
};
export const usePrefetchedTypeformAssets = ()=>{
    const prefetchedTypeformAssetsLinks = useContext(PrefetchedTypeformAssetsContext);
    return prefetchedTypeformAssetsLinks;
};
